import Feedback from '@map/components/Cv/ModernSkillAssessment/Recalibrate/Feedback.component.svg';
import { Typography } from '@mui/material';
import { useHelpCenterArticleUrl, useZendeskApi } from '@shared/lib/zendesk/hooks';
import Link from '@ui/Link';
import IllustratedDialog from '@ui/mobile/IllustratedDialog';
import SVGIllustration from '@ui/SVGIllustration';
import { MouseEventHandler, ReactNode, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

const MissingCodeDialog: FC<{ onClose: () => void }> = ({ onClose }) => {
  const zendesk = useZendeskApi();
  const learnMoreUrl = useHelpCenterArticleUrl(360015534017);
  const handleContactUs = useCallback<MouseEventHandler>(
    (e) => {
      e.preventDefault();
      zendesk.showWidget();
    },
    [zendesk],
  );
  const noCodeValues = useMemo(
    () => ({
      learn: (nodes: ReactNode[]) => (
        <Link fontSize="inherit" href={learnMoreUrl}>
          {nodes}
        </Link>
      ),
      contact: (nodes: ReactNode[]) => (
        <Link fontSize="inherit" onClick={handleContactUs} role="button">
          {nodes}
        </Link>
      ),
    }),
    [handleContactUs, learnMoreUrl],
  );

  return (
    <IllustratedDialog
      closable={true}
      illustration={<SVGIllustration src={Feedback} />}
      illustrationBackground="white"
      onClose={onClose}
      title={<FormattedMessage id="registration.missing_code.title" />}
      description={
        <>
          <Typography variant="body1">
            <FormattedMessage id="registration.missing_code.body" />
          </Typography>
          <Typography variant="body1">
            <FormattedMessage id="registration.missing_code.no_code" values={noCodeValues} />
          </Typography>
        </>
      }
    />
  );
};

export default MissingCodeDialog;
